import { SearchFilterStructureRo, RangesDimensions } from '@/types';

export const getRangesDimensions = (
  rangesDimensions: RangesDimensions,
  data: SearchFilterStructureRo,
) => {
  const roomsNumberMinimum =
    rangesDimensions.roomNumber?.length === 0 ||
    rangesDimensions.roomNumber[0] > data.roomsNumberMinimum
      ? data.roomsNumberMinimum
      : rangesDimensions.roomNumber[0];

  const roomsNumberMaximum =
    rangesDimensions.roomNumber?.length === 0 ||
    rangesDimensions.roomNumber[1] < data.roomsNumberMaximum
      ? data.roomsNumberMaximum
      : rangesDimensions.roomNumber[1];

  const priceMinimum =
    rangesDimensions.price?.length === 0 ||
    rangesDimensions.price[0] > data.originalSellPriceMinimum
      ? data.originalSellPriceMinimum
      : rangesDimensions.price[0];

  const priceMaximum =
    rangesDimensions.price?.length === 0 ||
    rangesDimensions.price[1] < data.originalSellPriceMaximum
      ? data.originalSellPriceMaximum
      : rangesDimensions.price[1];

  const rentPriceMinimum =
    rangesDimensions.rentPrice?.length === 0 ||
    rangesDimensions.rentPrice[0] > data.rentPriceMinimum
      ? data.rentPriceMinimum
      : rangesDimensions.rentPrice[0];

  const rentPriceMaximum =
    rangesDimensions.rentPrice?.length === 0 ||
    rangesDimensions.rentPrice[1] < data.rentPriceMaximum
      ? data.rentPriceMaximum
      : rangesDimensions.rentPrice[1];

  const areaMinimum =
    rangesDimensions.area?.length === 0 || rangesDimensions.area[0] > data.areaFromMinimum
      ? data.areaFromMinimum
      : rangesDimensions.area[0];

  const areaMaximum =
    rangesDimensions.area?.length === 0 || rangesDimensions.area[1] < data.areaFromMaximum
      ? data.areaFromMaximum
      : rangesDimensions.area[1];

  return {
    roomNumber: [roomsNumberMinimum, roomsNumberMaximum],
    price: [priceMinimum, priceMaximum],
    rentPrice: [rentPriceMinimum, rentPriceMaximum],
    area: [areaMinimum, areaMaximum],
  };
};
